import http from "@/apps/shared/baseService/config";

const base = {
  rota: "obras",
  nome: "Obras"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_obras: ({ commit, dispatch, getters }) => {
      if (localStorage.getItem("obras")) {
        commit("set_obras", JSON.parse(localStorage.getItem("obras")));
      } else {
        dispatch("enableLoading");
      }
      service
        .listar(getters.get_obras_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("obras", JSON.stringify(res.data));
          commit("set_obras", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_obra: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_obra, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("obras");
          commit("set_obra", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_obras");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_obra: ({ commit, dispatch, getters }, save) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_obra, imagens: getters.getLinks })
        .then((res) => {
          dispatch("disableLoading");
          localStorage.removeItem("obras");
          if (save) {
            commit("set_compra", {
              ...getters.get_compra,
              obra: res.data
            });
          }
          commit("set_obra", res.data);
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_obras");
          commit("set_modal_view_obra", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_obra: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_obras");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_obra: ({ commit }, payload) => {
      if (payload) {
        commit("set_obra", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_obra", true);
    },
    fecha_modal_view_obra: ({ commit }) => {
      commit("set_obra", {});
      commit("setLinks", []);
      commit("set_modal_view_obra", false);
    }
  },
  state: {
    obra: {},
    obras: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    obras_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_obra: false
  },
  mutations: {
    set_obra: (state, payload) => (state.obra = payload),
    set_obras: (state, payload) => (state.obras = payload),
    set_modal_view_obra: (state, payload) =>
      (state.modal_view_obra = payload)
  },
  getters: {
    get_obra: state => state.obra,
    get_obras: state => state.obras,
    get_modal_view_obra: state => state.modal_view_obra,
    get_obras_filtros: state => state.obras_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
